<template>
  <div id="challenges">
    <div id="content">
      <div class="container">
        <h1 class="page-title">
          <i class="fal fa-swords"></i>
          Défis
        </h1>
      </div>
      <div
        v-if="!isAdmin && in_progress_challenges.length == 0"
        style="margin-top: 10px; text-align: center"
      >
        <button
          class="button is-success is-medium"
          id="clear"
          @click="isComponentModalActive = true"
        >
          <span><i class="fal fa-swords"></i> Défier une Équipe</span>
        </button>
      </div>
      <inProgressChallenges
        v-if="in_progress_challenges.length > 0"
        id="leader-board"
        :in_progress_challenges="in_progress_challenges"
        :weezys="weezys"
      />
      <waitingChallenges
        id="leader-board"
        v-if="(!isAdmin && in_progress_challenges.length == 0 && waiting_challenges.length > 0) || isAdmin"
        :waiting_challenges="waiting_challenges"
        :weezys="weezys"
        :isAdmin="isAdmin"
      />
      <toAcceptChallenges
        v-if="!isAdmin && to_accept_challenges.length > 0 && in_progress_challenges.length == 0"
        id="leader-board"
        :to_accept_challenges="to_accept_challenges"
        :weezys="weezys"
      />
      <finishedChallenges
        id="leader-board"
        :finished_challenges="finished_challenges"
        :weezys="weezys"
      />
    </div>
    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
    >
      <form action="new-challenge">
        <div
          class="modal-card"
          style="width: 750px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Défier une Équipe</p>
          </header>
          <section class="modal-card-body">
            <div class="modal-line">
              <b-field
                label="Équipe à défier"
                required
              >
                <b-select
                  placeholder="Choisir l'équipe à défier"
                  v-model="challenged_id"
                  :required="true"
                >
                  <option
                    v-for="weezy in challengible_weezys"
                    :key="weezy.id"
                    :value="weezy.id"
                  >{{weezy.name}}</option>
                </b-select>
              </b-field>
            </div>
          </section>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            ><span><i class="fal fa-times"></i> Annuler</span></button>
            <button
              class="button is-success"
              type="button"
              @click="submitFormData"
            ><span><i class="fal fa-check"></i> Défier</span></button>
          </footer>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import waitingChallenges from "@/components/waitingChallenges";
import toAcceptChallenges from "@/components/toAcceptChallenges";
import inProgressChallenges from "@/components/inProgressChallenges";
import finishedChallenges from "@/components/finishedChallenges";

import http from "@/modules/request";

export default {
  name: "weezys",
  components: {
    waitingChallenges,
    toAcceptChallenges,
    inProgressChallenges,
    finishedChallenges
  },
  data() {
    return {
      isAddDisplayed: false,
      isComponentModalActive: false,
      isAdmin: true,
      challenges: {},
      weezys: [],
      waiting_challenges: [],
      to_accept_challenges: [],
      in_progress_challenges: [],
      finished_challenges: [],
      not_challengible_weezys: [],
      challenged_id: undefined,
      creation: undefined
    };
  },

  computed: {
    // Weezys with goals for selected GoalDate
    challengible_weezys: function() {
      return _.pickBy(
        this.weezys,
        function(u) {
          return (
            !this.not_challengible_weezys.includes(u.id) &&
            u.id != this.$store.state.weezy_id
          );
        }.bind(this)
      );
    }
  },

  mounted() {
    this.$parent.$refs.menubar.login = true;
    clearInterval(this.creation);
    this.getWeezys().then(_ => {
      this.getChallenges();
    });
    this.refreshData();
  },
  beforeDestroy() {
    clearInterval(this.creation);
  },
  methods: {
    getWeezys() {
      return new Promise((resolve, reject) => {
        http
          .get("/allWeezys")
          .then(response => {
            this.weezys = response.data;
            resolve();
          })
          .catch(error => {
            console.log(error);
            this.errored = true;
          });
      });
    },

    getChallenges() {
      this.waiting_challenges = [];
      this.to_accept_challenges = [];
      this.in_progress_challenges = [];
      this.finished_challenges = [];
      http
        .get("/challenges")
        .then(response => {
          let tmpChallenges = response.data;
          if (!this.isAdmin) {
            for (let chall of tmpChallenges) {
              //  Get challenge my team has sent
              if (
                chall.weezy1_id == this.$store.state.weezy_id &&
                !chall.is_accepted &&
                !chall.is_rejected
              ) {
                this.waiting_challenges.push(chall);
              }
              // Get challenges waiting for me
              if (
                chall.weezy2_id == this.$store.state.weezy_id &&
                !chall.is_accepted &&
                !chall.is_rejected
              ) {
                this.to_accept_challenges.push(chall);
              }
              // Get challenges in progress
              if (
                (chall.weezy1_id == this.$store.state.weezy_id ||
                  chall.weezy2_id == this.$store.state.weezy_id) &&
                chall.is_active
              ) {
                this.in_progress_challenges.push(chall);
                // If a challenge is in progress, then the weezy cannot be challenged :
                this.not_challengible_weezys.push(chall.weezy1_id);
                this.not_challengible_weezys.push(chall.weezy2_id);
              }
              // Get challenges finished
              if (
                (chall.weezy1_id == this.$store.state.weezy_id ||
                  chall.weezy2_id == this.$store.state.weezy_id) &&
                chall.is_finished &&
                !chall.is_active
              ) {
                this.finished_challenges.push(chall);
              }
            }
          } else {
            for (let chall of tmpChallenges) {
              // ALL Pending challenges
              if (!chall.is_accepted && !chall.is_rejected) {
                this.waiting_challenges.push(chall);
              }
              // All current challenges
              if (chall.is_active) {
                this.in_progress_challenges.push(chall);
              }
              // All finished challenges
              if (chall.is_finished && !chall.is_active) {
                this.finished_challenges.push(chall);
              }
            }
          }
          this.waiting_challenges.sort((a, b) => b.id - a.id);
          this.to_accept_challenges.sort((a, b) => b.id - a.id);
          this.in_progress_challenges.sort((a, b) => b.id - a.id);
          this.finished_challenges.sort((a, b) => b.id - a.id);
        })
        .catch(error => {
          console.log(error);
          this.errored = true;
        });
    },
    refreshData() {
      this.creation = setInterval(() => {
        this.getWeezys().then(_ => {
          this.getChallenges();
        });
      }, 90000);
    }
  }
};
</script>

<style scoped>
.content {
  background-color: #ffffff;
}
.add-weezy {
  width: auto;
  padding-top: 40px;
  padding-left: 30px;
}
</style>